import React, { Component } from "react";
import styles from "./TresureHunt.module.css";
import GetAllQuestiosn from "./getAllQuestions/GetAllQuestions";

class TresureHunt extends Component {
  state = {
    getQuestions: false,
  };

  onClickHandler = () => {
    this.setState({ getQuestions: true });
  };

  render() {
    let x = (
      <div className={styles.tresureHunt}>
        <div className={styles.heading}>
          We will be giving you {this.props.need}
          <div className={styles.toBest}>To the best we can!</div>
          You just need to give answers to some questions.
        </div>
        <button onClick={this.onClickHandler} className={styles.letsBegin}>
          Lets Begin
        </button>
      </div>
    );
    if (this.state.getQuestions)
      x = <GetAllQuestiosn cart={this.props.cart} need={this.props.need} />;
    return x;
  }
}

export default TresureHunt;
